import axios from 'axios';

import React, { useState } from 'react';
import { serverURL } from '../config/const';

export default function LoginDrawer({ isOpen, onClose, onLoginSuccess }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);

    const signupUrl = `${process.env.REACT_APP_COGNITO_AUTH_URL}/signup?` +
        `client_id=${process.env.REACT_APP_COGNITO_CLIENT_ID}&` +
        `response_type=code&` +
        `scope=email+openid+profile&` +
        `redirect_uri=${process.env.REACT_APP_REDIRECT_URI}`;

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError(null);

        try {
            // 2. Use axios.post instead of fetch
            // Note: axios automatically handles JSON stringifying and headers
            const response = await axios.post(`${serverURL}/api/login`, {
                email,
                password
            });

            // 3. Axios puts the response body in .data
            const data = response.data;

            // SUCCESS: Call the App.jsx handler function
            onLoginSuccess(data.user);

        } catch (error) {
            // 4. Axios errors are caught here; data is in error.response.data
            const errorMessage = error.response?.data?.message || 'Failed to log in';
            console.error("Login error:", errorMessage);
            setError(errorMessage);
        }
    };


    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex justify-end">
            <div className="fixed inset-0 bg-black opacity-50" onClick={onClose}></div>

            <div className="relative w-full max-w-md bg-white shadow-xl overflow-y-auto">
                <div className="p-8">
                    <button onClick={onClose} className="absolute top-4 right-4 text-gray-600 hover:text-gray-900">
                        ✕ Close
                    </button>

                    <h2 className="text-3xl font-bold mb-6 text-brandBlue">Sign In</h2>
                    {error && <p className="text-red-500 mb-4">{error}</p>}

                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <label className="block text-gray-700 mb-1">Email Address</label>
                            <input type="email" value={email} placeholder="email@example.com" onChange={(e) => setEmail(e.target.value)}
                                className="w-full border border-gray-300 p-3 rounded-lg" required />
                        </div>
                        <div className="mb-6">
                            <label className="block text-gray-700 mb-1">Password</label>
                            <input type="password" value={password} placeholder="••••••••" onChange={(e) => setPassword(e.target.value)}
                                className="w-full border border-gray-300 p-3 rounded-lg" required />
                        </div>
                        <button type="submit" className="w-full bg-blue-600 text-white font-semibold p-3 rounded-lg hover:bg-blue-700">
                            Login
                        </button>
                    </form>
                    <p className="mt-4 text-sm text-center">
                        Don't have an account?
                        <a href={signupUrl} className="text-blue-600 hover:underline">
                            Register here
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
}